import React from 'react';
import Login from './Login';

// Dedicated SCORM entrypoint route.
// For now it reuses the same visual/logic as Login and can diverge later.
const ScormLogin: React.FC = () => {
  return <Login />;
};

export default ScormLogin;
